import axios, { AxiosInstance } from 'axios';

let client: AxiosInstance | undefined;

/**
 * Axios client for mzcr-service. The components of @meddihub/mzcr-ui call `POST /invoke` on it.
 * Created on first use - the `MeddiApp` global must not be read just by importing the module.
 */
export const getMzcrClient = (): AxiosInstance => {
	if (!client) {
		// @ts-ignore – global from the layout
		const meddiAppGlobal = MeddiApp;
		client = axios.create({
			baseURL: meddiAppGlobal.socketUrl.replace(/\/$/, '') + '/mzcr',
			timeout: 30000,
			headers: meddiAppGlobal.jsHeaders,
		});
	}
	return client;
};
